import apiService from "../api";

export const getDashboardStat = async () => {
  console.log("getDashboardStat");
  return apiService(
    "/vaccine/client/analytics/vaccination/",
    "GET",
    undefined,
    true
  );
};
